<template>
  <el-container class="home">
    <el-main class="main-content">
      <!-- 左侧面板 -->
      <aside class="left-panel">
        <!-- 统计数据 -->
        <section class="panel-section">
          <div class="section-header">
            <span>统计数据</span>
            <span class="sub-title">STATISTICS</span>
            <el-dropdown trigger="click" class="more">
              <span>每日报表</span>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item>每日报表</el-dropdown-item>
                  <el-dropdown-item>每周报表</el-dropdown-item>
                  <el-dropdown-item>每月报表</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <div class="stats-grid">
            <div class="stat-item">
              <div class="stat-label">今日风险预警</div>
              <div class="stat-value">{{ stats.todayWarning }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">本周风险预警</div>
              <div class="stat-value">{{ stats.weekWarning }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">监控设备总数</div>
              <div class="stat-value">{{ stats.totalDevices }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">在线监控设备</div>
              <div class="stat-value">{{ stats.onlineDevices }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">当前检测任务</div>
              <div class="stat-value">{{ stats.currentTasks }}</div>
            </div>
          </div>
        </section>

        <!-- 本月风险分析 -->
        <section class="panel-section">
          <div class="section-header">
            <span>本月风险分析</span>
            <span class="sub-title">ANALYSIS</span>
            <el-icon class="more-icon"><More /></el-icon>
          </div>
          <div class="risk-analysis">
            <div class="no-data">无 数 据</div>
          </div>
        </section>

        <!-- 综合预警趋势 -->
        <section class="panel-section">
          <div class="section-header">
            <span>综合预警趋势</span>
            <span class="sub-title">COMPREHENSIVE</span>
            <el-icon class="more-icon"><More /></el-icon>
          </div>
          <div class="trend-chart">
            <div class="chart-legend">
              <span class="legend-item"
                ><span class="legend-color warning"></span>预警数</span
              >
              <span class="legend-item"
                ><span class="legend-color untreated"></span>未处理</span
              >
              <span class="legend-item"
                ><span class="legend-color treated"></span>已处理</span
              >
              <span class="legend-item"
                ><span class="legend-color known"></span>已知略</span
              >
              <span class="legend-item"
                ><span class="legend-color processing"></span>处理中</span
              >
            </div>
            <div class="chart-area">
              <div
                class="chart-bars"
                v-for="item in trendData"
                :key="item.date"
              >
                <div class="bar" :style="{ height: item.value + '%' }"></div>
                <div class="bar-label">{{ item.date }}</div>
              </div>
            </div>
          </div>
        </section>
      </aside>

      <!-- 中央地图区域 -->
      <main class="center-panel">
        <div class="map-controls">
          <el-icon><FullScreen /></el-icon>
          <el-icon><VideoPlay /></el-icon>
          <el-icon><Search /></el-icon>
          <el-icon class="active"><Check /></el-icon>
        </div>
        <div class="map-container">
          <img
            src="https://picsum.photos/id/1031/1920/1080"
            alt="卫星地图"
            class="map-image"
          />
        </div>
        <div class="side-controls">
          <el-icon><Expand /></el-icon>
          <el-icon><VideoCamera /></el-icon>
          <el-icon><Setting /></el-icon>
          <el-icon><RotateRight /></el-icon>
        </div>
      </main>

      <!-- 右侧面板 -->
      <aside class="right-panel">
        <!-- 实时事件 -->
        <section class="panel-section">
          <div class="section-header">
            <span>实时事件</span>
            <span class="sub-title">EVENTS</span>
            <span class="more">更多事件</span>
          </div>
          <div class="event-tabs">
            <div class="tab-item">
              <span class="tab-label">今日已处理</span>
              <span class="tab-value green">{{ eventStats.todayHandled }}</span>
            </div>
            <div class="tab-item">
              <span class="tab-label">今日未处理</span>
              <span class="tab-value orange">{{
                eventStats.todayUnhandled
              }}</span>
            </div>
          </div>
          <div class="event-list">
            <div class="event-item" v-for="item in eventList" :key="item.id">
              <div class="event-thumb">
                <img :src="item.thumb" alt="事件截图" />
              </div>
              <div class="event-info">
                <div class="event-title">
                  <el-icon><Warning /></el-icon>
                  {{ item.title }}
                </div>
                <div class="event-source">
                  <el-icon><VideoCamera /></el-icon>
                  {{ item.source }}
                  <el-icon><Position /></el-icon>
                </div>
                <div class="event-time">{{ item.time }}</div>
                <div class="event-level">Lv.{{ item.level }} 二级</div>
              </div>
            </div>
          </div>
        </section>

        <!-- 本周安全之星 -->
        <section class="panel-section">
          <div class="section-header">
            <span>本周安全之星</span>
            <span class="sub-title">STAR</span>
            <el-icon><Trophy /></el-icon>
          </div>
          <div class="star-list">
            <div
              class="star-item"
              v-for="(item, index) in starList"
              :key="item.id"
            >
              <div class="star-rank">{{ index + 1 }}</div>
              <div class="star-info">
                <div class="star-name">{{ item.name }}</div>
                <div class="star-status">{{ item.status }}</div>
              </div>
            </div>
          </div>
        </section>
      </aside>
    </el-main></el-container
  >
</template>

<script setup>
import { ref, reactive } from "vue";
import {
  Cpu,
  Download,
  Search,
  More,
  FullScreen,
  VideoPlay,
  Check,
  Expand,
  VideoCamera,
  Setting,
  RotateRight,
  Warning,
  Position,
  Trophy,
} from "@element-plus/icons-vue";

// 模拟数据
const company = ref("中国石油");

const stats = reactive({
  todayWarning: 0,
  weekWarning: 0,
  totalDevices: 10,
  onlineDevices: 5,
  currentTasks: 1,
});

const trendData = ref([
  { date: "02/25", value: 0 },
  { date: "02/26", value: 0 },
  { date: "02/27", value: 0 },
  { date: "02/28", value: 0 },
  { date: "03/01", value: 0 },
  { date: "03/02", value: 0 },
  { date: "03/03", value: 0 },
]);

const eventStats = reactive({
  todayHandled: 0,
  todayUnhandled: 0,
});

const eventList = ref([
  {
    id: 1,
    title: "离岗检测",
    source: "中国石油",
    time: "2026-02-24 14:38",
    level: 2,
    thumb: "https://picsum.photos/id/1/120/80",
  },
  {
    id: 2,
    title: "离岗检测",
    source: "中国石油",
    time: "2026-02-24 13:51",
    level: 2,
    thumb: "https://picsum.photos/id/2/120/80",
  },
  {
    id: 3,
    title: "离岗检测",
    source: "测试",
    time: "2026-02-10 14:06",
    level: 2,
    thumb: "https://picsum.photos/id/3/120/80",
  },
  {
    id: 4,
    title: "离岗检测",
    source: "中国石油",
    time: "2026-02-05 12:39",
    level: 2,
    thumb: "https://picsum.photos/id/4/120/80",
  },
  {
    id: 5,
    title: "离岗检测",
    source: "中国石油",
    time: "2026-02-05 12:39",
    level: 2,
    thumb: "https://picsum.photos/id/5/120/80",
  },
]);

const starList = ref([
  { id: 1, name: "测试", status: "无报警" },
  { id: 2, name: "兰州石化榆林化工有限公司", status: "无报警" },
]);
</script>

<style lang="scss" scoped>
.home {
  height: 100%;
  background: #0a1020;
  color: #d9e6f7;
  font-family: "Microsoft YaHei", sans-serif;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  display: flex;
  padding: 0;
  gap: 10px;
}

.left-panel,
.right-panel {
  width: 320px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.center-panel {
  flex: 1;
  background: #0f1a30;
  border: 1px solid #1a3a6a;
  border-radius: 4px;
  position: relative;
  overflow: hidden;

  .map-controls {
    position: absolute;
    top: 10px;
    left: 10px;
    display: flex;
    gap: 10px;
    z-index: 10;

    .el-icon {
      width: 32px;
      height: 32px;
      background: rgba(15, 26, 48, 0.8);
      border: 1px solid #1a3a6a;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #00ccff;
      cursor: pointer;

      &.active {
        background: #00ccff;
        color: #050b1a;
      }
    }
  }

  .side-controls {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    gap: 10px;
    z-index: 10;

    .el-icon {
      width: 32px;
      height: 32px;
      background: rgba(15, 26, 48, 0.8);
      border: 1px solid #1a3a6a;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #00ccff;
      cursor: pointer;
    }
  }

  .map-container {
    width: 100%;
    height: 100%;
    position: relative;

    .map-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.panel-section {
  background: #0f1a30;
  border: 1px solid #1a3a6a;
  border-radius: 4px;
  padding: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;

  .section-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    font-size: 16px;
    color: #d9e6f7;
    border-bottom: 1px solid #1a3a6a;
    padding-bottom: 5px;

    .sub-title {
      font-size: 12px;
      color: #00ccff;
      text-transform: uppercase;
    }

    .more,
    .more-icon {
      margin-left: auto;
      color: #00ccff;
      cursor: pointer;
    }
  }
}

.stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;

  .stat-item {
    background: rgba(26, 58, 106, 0.3);
    border: 1px solid #1a3a6a;
    border-radius: 4px;
    padding: 10px;
    text-align: center;

    .stat-label {
      font-size: 14px;
      color: #8aa2c2;
      margin-bottom: 5px;
    }

    .stat-value {
      font-size: 28px;
      font-weight: bold;
      color: #ffff00;
      text-shadow: 0 0 10px #ffff00;
    }
  }
}

.risk-analysis {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  .no-data {
    font-size: 20px;
    color: #00ccff;
    text-shadow: 0 0 10px #00ccff;
  }
}

.trend-chart {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .chart-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    font-size: 12px;
    color: #8aa2c2;

    .legend-item {
      display: flex;
      align-items: center;
      gap: 5px;

      .legend-color {
        width: 12px;
        height: 12px;
        border-radius: 2px;

        &.warning {
          background: #ffcc00;
        }
        &.untreated {
          background: #ff6600;
        }
        &.treated {
          background: #00ff66;
        }
        &.known {
          background: #00ccff;
        }
        &.processing {
          background: #ff0000;
        }
      }
    }
  }

  .chart-area {
    flex: 1;
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
    padding-bottom: 20px;

    .chart-bars {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 5px;

      .bar {
        width: 15px;
        background: linear-gradient(180deg, #00ccff 0%, #1a3a6a 100%);
        border-radius: 2px 2px 0 0;
      }

      .bar-label {
        font-size: 10px;
        color: #8aa2c2;
      }
    }
  }
}

.event-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;

  .tab-item {
    flex: 1;
    background: rgba(26, 58, 106, 0.3);
    border: 1px solid #1a3a6a;
    border-radius: 4px;
    padding: 10px;
    text-align: center;

    .tab-label {
      font-size: 14px;
      color: #8aa2c2;
      margin-bottom: 5px;
    }

    .tab-value {
      font-size: 24px;
      font-weight: bold;

      &.green {
        color: #00ff66;
        text-shadow: 0 0 10px #00ff66;
      }
      &.orange {
        color: #ff6600;
        text-shadow: 0 0 10px #ff6600;
      }
    }
  }
}

.event-list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: #0f1a30;
  }
  &::-webkit-scrollbar-thumb {
    background: #1a3a6a;
    border-radius: 2px;
  }

  .event-item {
    display: flex;
    gap: 10px;
    background: rgba(26, 58, 106, 0.3);
    border: 1px solid #1a3a6a;
    border-radius: 4px;
    padding: 10px;

    .event-thumb {
      width: 80px;
      height: 60px;
      border-radius: 4px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .event-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 5px;
      font-size: 12px;

      .event-title {
        display: flex;
        align-items: center;
        gap: 5px;
        color: #d9e6f7;
        font-weight: bold;

        .el-icon {
          color: #ffcc00;
        }
      }

      .event-source {
        display: flex;
        align-items: center;
        gap: 5px;
        color: #8aa2c2;

        .el-icon {
          color: #00ccff;
        }
      }

      .event-time {
        color: #8aa2c2;
      }

      .event-level {
        color: #ff6600;
        font-weight: bold;
      }
    }
  }
}

.star-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .star-item {
    display: flex;
    align-items: center;
    gap: 10px;
    background: rgba(26, 58, 106, 0.3);
    border: 1px solid #1a3a6a;
    border-radius: 4px;
    padding: 10px;

    .star-rank {
      width: 30px;
      height: 30px;
      background: linear-gradient(135deg, #ffcc00 0%, #ff6600 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #050b1a;
      font-weight: bold;
    }

    .star-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 5px;

      .star-name {
        color: #d9e6f7;
        font-weight: bold;
      }

      .star-status {
        font-size: 12px;
        color: #00ff66;
      }
    }
  }
}
</style>
